exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-panel{z-index:99;position:absolute;top:5px;right:0px}.loading-panel>img{width:60px;height:auto}.add-top-position{top:80px}", ""]);

// exports
